module.exports = __webpack_public_path__ + "img/sleeve cap front.1de4a411.png";